// https://chat.google.com/room/AAAAEFrn1Qw?cls=7
export const SPACE_URL = `https://chat.google.com/room/`;

export function spaceUrlFromId(spaceId?: string): string {
  if (!spaceId) {
    return '';
  }
  return `${SPACE_URL}${spaceId}`;
}
